<div class="project-history-container">
  <!-- En-tête avec statistiques -->
  <div class="dashboard-content">
    <div class="dashboard-header">
      <div class="header-content">
        <div class="header-title-block">
          <h1>Historique des Comparaisons</h1>
        </div>

        <div class="user-status-summary" *ngIf="userStatusCounts.length > 0">
          <div class="user-status-card" *ngFor="let counts of userStatusCounts">
            <div class="user-status-name">{{ counts.user_name }}</div>
            <div class="user-status-total">{{ counts.total_projects }} projet(s)</div>
            <div class="user-status-counts">
              <span class="user-status-pill pending">{{ counts.a_traiter_count }} à traiter</span>
              <span class="user-status-pill done">{{ counts.traite_count }} traité(s)</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Actions -->
    <p-card styleClass="actions-card">
      <ng-template pTemplate="content">
        <div class="actions-bar">
          <div class="search-section">
            <span class="p-input-icon-left">
              <i class="pi pi-search"></i>
              <input pInputText type="text" [(ngModel)]="searchText"
                placeholder="Rechercher un projet, email ou téléphone..." (ngModelChange)="applyFilters()" />
            </span>
          </div>

          <div class="filters-section">
            <div class="filters-row">
              <p-dropdown [options]="typeProjetFilter" [(ngModel)]="selectedTypeProjet" placeholder="Type de projet"
                (onChange)="applyFilters()" [showClear]="true"></p-dropdown>

              <p-dropdown [options]="niveauFilter" [(ngModel)]="selectedNiveau" placeholder="Niveau (Cotisation)"
                (onChange)="applyFilters()" [showClear]="true"></p-dropdown>

              <p-dropdown [options]="origineFilter" [(ngModel)]="selectedOrigine" placeholder="Origine"
                (onChange)="applyFilters()" [showClear]="true"></p-dropdown>

              <p-dropdown [options]="statusFilter" [(ngModel)]="selectedStatus" placeholder="Statut"
                (onChange)="applyFilters()" [showClear]="true"></p-dropdown>

              <p-dropdown [options]="emailValidityFilter" [(ngModel)]="selectedEmailValidity"
                placeholder="Validité email" (onChange)="applyFilters()" [showClear]="true"
                optionLabel="label" optionValue="value"></p-dropdown>

              <p-dropdown [options]="userOptions" [(ngModel)]="selectedUser" placeholder="Utilisateur"
                (onChange)="applyFilters()" [showClear]="true" optionLabel="label" optionValue="value"></p-dropdown>

              <p-calendar [(ngModel)]="dateRange" selectionMode="range" [readonlyInput]="false"
                placeholder="Date de création" dateFormat="dd/mm/yy" (ngModelChange)="applyFilters()"
                (onClearClick)="applyFilters()" [showIcon]="true" [showClear]="true" [numberOfMonths]="2">
              </p-calendar>
            </div>
          </div>

          <div class="toolbar-action-buttons">
            <input #csvImportInput type="file" accept=".csv,.txt,.xlsx,.xls" class="hidden-file-input" style="display: none;"
              (change)="onCsvFileSelected($event)">

            <div class="action-execute-group">
              <p-dropdown [options]="actionMenuOptions" [(ngModel)]="selectedAction" optionLabel="label"
                optionValue="value" placeholder="Choisir une action" [showClear]="true"
                (onChange)="onActionMenuChange()">
              </p-dropdown>

              <p-button label="Exécuter" icon="pi pi-play" (onClick)="executeSelectedAction()"
                [disabled]="!canExecuteSelectedAction()" [loading]="isExecutingSelectedAction()"
                styleClass="p-button-primary" pTooltip="Exécuter l'action sélectionnée"></p-button>
            </div>

            <div class="toolbar-utility-buttons">
              <p-button icon="pi pi-times" (onClick)="resetFilters()" [disabled]="!hasActiveFilters()"
                styleClass="p-button-secondary" pTooltip="Effacer tous les filtres"></p-button>

              <p-button icon="pi pi-refresh" (onClick)="refreshFromDatabase()" [loading]="importingCsv" pTooltip="Actualiser"></p-button>
            </div>
          </div>
        </div>
      </ng-template>
    </p-card>

    <!-- Message de filtres actifs -->
    <div *ngIf="hasActiveFilters()" class="active-filters-banner">
      <div class="active-filters-banner-content">
        <i class="pi pi-info-circle"></i>
        <span>Des filtres sont actuellement appliqués.</span>
      </div>
      <button type="button" class="active-filters-clear-btn" (click)="resetFilters()" aria-label="Supprimer les filtres"
        pTooltip="Supprimer tous les filtres">
        <i class="pi pi-times"></i>
      </button>
    </div>

    <!-- Barre de sélection -->
    <div class="selection-bar" *ngIf="selectedComparisons.length > 0 || selectAllChecked">
      <div class="selection-info">
        <i class="pi pi-check-circle"></i>
        <span>{{ selectedComparisons.length }} comparaison(s) sélectionnée(s)</span>
      </div>
      <div class="selection-actions">
        <p-button *ngIf="filteredHistory.length > 0" label="Sélectionner tout le tableau" icon="pi pi-list-check"
          (onClick)="selectAll()" styleClass="p-button-secondary p-button-sm"></p-button>
        <p-button label="Désélectionner" icon="pi pi-times" (onClick)="clearSelection()"
          styleClass="p-button-text p-button-sm"></p-button>
      </div>
    </div>

    <!-- Tableau des comparaisons -->
    <div class="table-container">
      <p-table [value]="filteredHistory" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[5, 10, 20, 50]"
      [sortField]="'date'" [sortOrder]="-1" responsiveLayout="scroll"
      [globalFilterFields]="['userName', 'principalName', 'principalFirstName']" class="history-table">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 3rem">
            <p-checkbox [(ngModel)]="selectAllChecked" (onChange)="toggleSelectAll($event)"
              [binary]="true"></p-checkbox>
          </th>
          <th>Client</th>
          <th>Projet</th>
          <th>Composition Familiale</th>
          <th pSortableColumn="totalResults">
            Statut
            <p-sortIcon field="totalResults"></p-sortIcon>
          </th>
          <th pSortableColumn="userName">
            Utilisateur
            <p-sortIcon field="userName"></p-sortIcon>
          </th>
          <th pSortableColumn="date">
            Créé le
            <p-sortIcon field="date"></p-sortIcon>
          </th>
          <th>Actions</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-comparison>
        <tr [class.selected-row]="isSelected(comparison.id)">
          <td>
            <p-checkbox [(ngModel)]="comparison.selected" (onChange)="toggleSelection(comparison)"
              [binary]="true"></p-checkbox>
          </td>
          <td>
            <div class="client-info">
              <div class="client-avatar person">
                {{ getClientInitials(comparison) }}
              </div>
              <div class="client-details-text">
                <div class="client-name">{{ comparison.principalFirstName }} {{ comparison.principalName }}</div>
                <div class="client-email" *ngIf="comparison.userEmail">
                  <a [href]="'mailto:' + comparison.userEmail" class="email-link">{{ comparison.userEmail }}</a>
                </div>
                <div class="client-type" *ngIf="comparison.conjoint">
                  <i class="pi pi-users"></i> Conjoint
                </div>
                <div class="client-badge-row">
                  <p-tag [value]="comparison.userName" severity="info" styleClass="client-badge-tag" [rounded]="true"></p-tag>
                </div>
                <div *ngIf="getCommentaire(comparison)" class="client-comment-badge mt-2 p-1 px-2 border-round surface-100 border-left-3 border-purple-500 text-xs text-purple-900" style="max-width: 220px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;" [pTooltip]="getCommentaire(comparison)" tooltipPosition="top">
                  <i class="pi pi-comment text-purple-600 mr-1"></i>
                  <span>{{ getCommentaire(comparison) }}</span>
                </div>
              </div>
            </div>
          </td>

          <td>
            <div class="project-info-cell">
              <div class="project-type-tags">
                <p-tag [value]="isPro(comparison.regimeObligatoire) ? 'Professionnel' : 'Particulier'"
                  [severity]="'success'" [rounded]="true"></p-tag>
                <p-tag *ngIf="comparison.origine" [value]="formatOrigine(comparison.origine)"
                  [severity]="getOrigineColor(comparison.origine)" [rounded]="true"></p-tag>
              </div>
              <div class="project-subinfo">
                <span class="project-name-text">Mutuelle Santé</span>
                <span class="project-pret-type" *ngIf="comparison.regimeObligatoire">{{ comparison.regimeObligatoire }}</span>
              </div>
              <div class="project-id-small">
                <span>CAS{{ comparison.date | date:'yyyyMMdd' }}-{{ (comparison.id || '').toString().padStart(10, '0') }}</span>
              </div>
            </div>
          </td>

          <td>
            <div class="project-info-cell">
              <div class="project-type-tags">
                <p-tag [value]="getFamilyComposition(comparison)"
                  [severity]="comparison.conjoint ? 'success' : 'info'" [rounded]="true"></p-tag>
              </div>
              <div class="project-subinfo" *ngIf="comparison.conjoint || comparison.enfants">
                <div *ngIf="comparison.conjoint" class="project-name-text">
                  <i class="pi pi-users"></i>
                  {{ comparison.conjoint.firstName }} {{ comparison.conjoint.name }}
                  ({{ comparison.conjoint.age }} ans)
                </div>

                <div *ngIf="comparison.enfants" class="project-pret-type">
                  <i class="pi pi-user"></i>
                  {{ comparison.enfants.count }} enfant{{ comparison.enfants.count > 1 ? 's' : '' }}
                </div>
              </div>
            </div>
          </td>

          <td>
            <div class="status-cell">
              <p-tag [value]="comparison.totalResults > 0 ? 'TRAITÉ' : 'À TRAITER'"
                [severity]="comparison.totalResults > 0 ? 'danger' : 'success'"
                [rounded]="true" styleClass="status-tag">
              </p-tag>
            </div>
          </td>

          <td>
            <div class="user-cell">
              <div class="user-name">{{ comparison.userName }}</div>
              <div class="user-email">{{ comparison.userEmail }}</div>
            </div>
          </td>

          <td>
            <div class="date-cell">
              <div class="date-main">{{ formatDate(comparison.date) }}</div>
            </div>
          </td>

          <td>
            <div class="row-action-buttons-wrap">
              <div class="row-action-buttons">
                <p-button icon="pi pi-upload" pTooltip="Charger" (onClick)="loadComparison(comparison)"
                  styleClass="p-button-text p-button-success"></p-button>
                <p-button icon="pi pi-copy" pTooltip="Dupliquer" (onClick)="duplicateComparison(comparison)"
                  styleClass="p-button-text p-button-warning"></p-button>
                <p-button icon="pi pi-eye" pTooltip="Voir" (onClick)="showDetails(comparison)" 
                  styleClass="p-button-text p-button-info"></p-button>
                <p-button icon="pi pi-sync" pTooltip="Ouvrir la transaction associée" (onClick)="openTransaction(comparison)"
                  styleClass="p-button-text p-button-help"></p-button>
                <p-button icon="pi pi-trash" pTooltip="Supprimer" (onClick)="deleteComparison(comparison)"
                  styleClass="p-button-text p-button-danger"></p-button>
              </div>
              <!-- Ringover : ligne en dessous -->
              <ng-container *ngIf="projectPhoneE164(comparison) as phone">
                <app-ringover-click-to-call
                  [phoneNumber]="phone"
                  [displayName]="comparison.principalFirstName + ' ' + comparison.principalName">
                </app-ringover-click-to-call>
              </ng-container>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="8" class="empty-message">
            <div class="empty-state">
              <i class="pi pi-history empty-icon"></i>
              <h3>Aucune comparaison trouvée</h3>
              <p>Il n'y a pas encore de comparaisons dans l'historique ou aucune ne correspond aux filtres appliqués.
              </p>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
    </div>
  </div>

  <!-- Menu SMS Rapide -->
  <p-menu #smsMenu [popup]="true" [model]="smsMenuItems" appendTo="body"></p-menu>

  <!-- Dialog de détails -->
  <p-dialog header="Détails de la comparaison" [(visible)]="showDetailDialog" [modal]="true"
    [style]="{ width: '80vw', maxWidth: '1200px' }" [draggable]="false" [resizable]="false">
    <div *ngIf="selectedComparison" class="comparison-details">
      <!-- Informations générales -->
      <p-panel header="Informations générales" class="detail-panel">
        <div class="detail-grid">
          <div class="detail-row">
            <span class="detail-label">Date de comparaison:</span>
            <span class="detail-value">{{ formatDate(selectedComparison.date) }}</span>
          </div>
          <div class="detail-row">
            <span class="detail-label">Utilisateur:</span>
            <span class="detail-value">{{ selectedComparison.userName }} ({{ selectedComparison.userEmail }})</span>
          </div>
          <div class="detail-row">
            <span class="detail-label">Régime obligatoire:</span>
            <span class="detail-value">{{ selectedComparison.regimeObligatoire }}</span>
          </div>
          <div class="detail-row">
            <span class="detail-label">Code postal:</span>
            <span class="detail-value">{{ selectedComparison.codePostal }}</span>
          </div>
          <div class="detail-row">
            <span class="detail-label">Date d'effet:</span>
            <span class="detail-value">{{ selectedComparison.dateEffet }}</span>
          </div>
          <div class="detail-row">
            <span class="detail-label">Situation familiale:</span>
            <span class="detail-value">{{ selectedComparison.situationFamiliale }}</span>
          </div>
        </div>
      </p-panel>

      <!-- Assurés -->
      <p-panel header="Personnes assurées" class="detail-panel">
        <!-- Assuré principal -->
        <div class="assure-section">
          <h4><i class="pi pi-user"></i> Assuré Principal</h4>
          <div class="assure-details">
            <span class="assure-name">{{ selectedComparison.principalFirstName }} {{ selectedComparison.principalName
              }}</span>
            <span class="assure-info">{{ selectedComparison.principalAge }} ans - Né le {{
              selectedComparison.principalBirthDate }}</span>
          </div>
        </div>

        <!-- Conjoint -->
        <div *ngIf="selectedComparison.conjoint" class="assure-section">
          <h4><i class="pi pi-users"></i> Conjoint</h4>
          <div class="assure-details">
            <span class="assure-name">{{ selectedComparison.conjoint.firstName }} {{ selectedComparison.conjoint.name
              }}</span>
            <span class="assure-info">{{ selectedComparison.conjoint.age }} ans - Né le {{
              selectedComparison.conjoint.birthDate }}</span>
          </div>
        </div>

        <!-- Enfants -->
        <div *ngIf="selectedComparison.enfants && selectedComparison.enfants.count > 0" class="assure-section">
          <h4><i class="pi pi-user"></i> Enfants ({{ selectedComparison.enfants.count }})</h4>
          <div class="enfants-list">
            <div *ngFor="let enfant of selectedComparison.enfants.details; let i = index" class="enfant-item">
              <span class="enfant-label">Enfant {{ i + 1 }}:</span>
              <span class="enfant-info">{{ enfant.age }} ans - Né le {{ enfant.birthDate }}</span>
            </div>
          </div>
        </div>
      </p-panel>

      <!-- Résultats -->
      <p-panel header="Résultats de la comparaison ({{ selectedComparison.totalResults }})" class="detail-panel">
        <div class="results-grid">
          <div *ngFor="let result of selectedComparison.results" class="result-card">
            <div class="result-header">
              <h5>{{ result.assureur }}</h5>
              <span class="result-formule">{{ result.formule }}</span>
            </div>
            <div class="result-price">
              <span class="price-value">{{ result.prix }}€</span>
              <span class="price-label">/mois</span>
            </div>
            <div class="result-guarantees" *ngIf="result.garanties">
              <div *ngFor="let guarantee of result.garanties | keyvalue" class="guarantee-item">
                <span class="guarantee-name">{{ guarantee.key }}:</span>
                <span class="guarantee-value">{{ guarantee.value }}</span>
              </div>
            </div>
          </div>
        </div>
      </p-panel>
    </div>

    <!-- Actions SMS -->
    <ng-template pTemplate="footer">
      <div class="flex justify-content-between w-full">
        <div class="flex gap-2">
          <p-button label="SMS RDV manqué / NRP" icon="pi pi-mobile" (onClick)="prepareSms('rdv')" styleClass="p-button-warning" size="small"></p-button>
          <p-button label="SMS Devis Envoyé" icon="pi pi-mobile" (onClick)="prepareSms('devis_envoye')" severity="info" size="small"></p-button>
          <p-button label="Renvoi DEVIS+SMS" icon="pi pi-mobile" (onClick)="prepareSms('relance')" severity="secondary" size="small"></p-button>
        </div>
        <p-button label="Fermer" icon="pi pi-times" (onClick)="showDetailDialog = false" [text]="true"></p-button>
      </div>
    </ng-template>
  </p-dialog>

  <!-- Dialog d'envoi SMS -->
  <p-dialog header="Envoyer un SMS" [(visible)]="showSmsDialog" [modal]="true" [style]="{ width: '400px' }">
    <div class="flex flex-column gap-3 p-3">
      <div class="field" *ngIf="smsType === 'rdv'">
        <label for="rdvTime" class="block font-bold mb-2">Heure du RDV (ex: 14H30)</label>
        <input id="rdvTime" type="text" pInputText [(ngModel)]="rdvTime" (input)="updateSmsContent()" class="w-full" placeholder="XXHXX" />
      </div>
      <div class="field">
        <label class="block font-bold mb-2">Message</label>
        <textarea class="p-inputtext w-full" [(ngModel)]="smsContent" rows="12" style="resize: vertical;"></textarea>
      </div>
    </div>
    <ng-template pTemplate="footer">
      <p-button label="Annuler" icon="pi pi-times" (onClick)="showSmsDialog = false" severity="secondary" [text]="true"></p-button>
      <p-button label="Envoyer" icon="pi pi-send" (onClick)="sendSms()" [loading]="sendingSms" [disabled]="!smsContent.trim()"></p-button>
    </ng-template>
  </p-dialog>
</div>

<!-- Toast pour les messages -->
<p-toast></p-toast>

<!-- Dialog de confirmation -->
<p-confirmDialog></p-confirmDialog>